
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { FaInstagram } from "react-icons/fa";
import { RiTwitterLine, RiLinkedinLine } from "react-icons/ri";

function Footer() {
  
  return (
    <section className="bg-bg-black bg-cover overflow-hidden">
      <div className="container mx-auto">
        <div className="md:w-full w-11/12 mx-auto py-[64px] md:py-[100px]">
          <div className="pb-[50px] flex flex-col md:flex-row md:items-center items-start justify-between border-b border-white border-opacity-10">
            <div>
              <h3 className="font-sfprobold text-white font-extrabold md:text-5xl text-[28px] md:leading-[56px] leading-[36px]">
                <span className="opacity-50">Have an idea?</span> <br />
                Lets build and scale it
              </h3>
            </div>
            <div className="mt-10 md:mt-0">
              <Link
                className={`ease-in-out duration-300 rounded-[600px] flex items-center justify-center px-6 py-4 bg-white`}
                to="mailto: hello@protishq.com"
              >
                <span
                  className={`text-black font-bold font-sfpro`}
                >
                  Lets talk
                </span>
                <HiArrowRight
                  size={20}
                  className={"ml-2 text-black"}
                />
              </Link>
            </div>
          </div>
          <div>
            <div className="flex flex-col md:flex-row md:items-center items-start justify-between">
              <div className="pt-[50px]">
                <h3 className="text-[22px] font-sfpro text-white opacity-50">
                  Reach us via socials
                </h3>
                <div className="mt-5 flex items-center">
                  <Link to="https://www.instagram.com/welcometoprotis/" target="_blank" className="bg-transparent border border-white rounded-[50%] flex items-center justify-center h-[56px] w-[56px] mx-3">
                    <FaInstagram size={20} color="#ffffff" />
                  </Link>
                  <Link to="https://twitter.com/welcometoprotis" target="_blank" className="bg-transparent border border-white rounded-[50%] flex items-center justify-center h-[56px] w-[56px] mx-3">
                    <RiTwitterLine size={23} color="#ffffff" />
                  </Link>
                  <Link to="https://www.linkedin.com/company/protis-studios/" target="_blank" className="bg-transparent border border-white rounded-[50%] flex items-center justify-center h-[56px] w-[56px] mx-3">
                    <RiLinkedinLine size={23} color="#ffffff" />
                  </Link>
                </div>
              </div>

              <div className="flex items-start justify-start flex-col md:mt-0 mt-8">
                <h3 className="text-base text-white opacity-70 font-sfpro">
                  Copyright © Protis Studios{" "}
                </h3>
                <ul className="items-center flex">
                  <li
                    className={`mr-2 py-3 cursor-pointer font-normal text-white`}
                  >
                    <Link
                      to="/privacy-policy"
                      className="text-base font-sfpro font-normal"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li
                    className={`mx-3 py-3 cursor-pointer font-normal text-white`}
                  >
                    <Link
                      to="/our-works"
                      className="text-base font-sfpro font-normal"
                    >
                      CAC Approved
                    </Link>
                  </li>
                  <li
                    className={` mx-3 py-3 cursor-pointer font-normal text-white`}
                  >
                    <Link
                      to="/legal"
                      className="text-base font-sfpro font-normal"
                    >
                      Legal
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="h-[80px] md:h-[250px] w-full">
          <h3 className="md:text-[289px] text-[90px] font-sfprobold text-black opacity-10 text-center text_outline ">
            Protis HQ
          </h3>
        </div>
      </div>
    </section>
  );
}

export default Footer;
